// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { buildUrl } from '../../../../../common/utils/urlUtil';
import getClientConfig from '../../../../utils/getClientConfig';
import { getUtmDataFromHref } from '../../../../analytics/utmClientUtils';
import { getBoardUrl } from '../../../../../common/permissions/urlPermissionUtils';
import { isPlatformElectronMac, isPlatformIframe } from '../../../../platform/utils/platformDetailsUtils';

// Selectors
import { getCurrentBoardId } from '../../../../reducers/currentBoardId/currentBoardIdSelector';
import { getPlatformDetailsSelector } from '../../../../platform/platformSelector';
import { getUrlPermissionId } from '../../../../app/routingSelector';

// Components
import CurrentBoardHeaderUtil from '../CurrentBoardHeaderUtil';
import Icon from '../../../../components/icons/Icon';

// Styles
import './MadeWithMilanoteUtil.scss';

const mapStateToProps = createStructuredSelector({
    currentBoardId: getCurrentBoardId,
    permissionId: getUrlPermissionId,
});

let OpenInMilanoteUtil = ({ currentBoardId, permissionId }) => (
    <CurrentBoardHeaderUtil className="OpenInMilanoteUtil">
        <a
            href={getBoardUrl({ boardId: currentBoardId, permissionId })}
            target="_blank"
            rel="noopener noreferrer nofollow"
        >
            Open in Milanote <Icon name="chevron-right-orange" />
        </a>
    </CurrentBoardHeaderUtil>
);

OpenInMilanoteUtil.propTypes = {
    currentBoardId: PropTypes.string,
    permissionId: PropTypes.string,
};

OpenInMilanoteUtil = connect(mapStateToProps)(OpenInMilanoteUtil);

/**
 * Adds UTM parameters to the marketing site URL if they're on the document location href.
 */
const buildPublicSiteUrl = (platformDetails) => {
    const clientConfig = getClientConfig();
    const publicSiteUrl = clientConfig.marketingUrl;

    const utmParams = !isPlatformElectronMac(platformDetails) ? getUtmDataFromHref(document.location.href) : null;

    return buildUrl(publicSiteUrl, utmParams);
};

const MadeWithMilanoteUtil = () => {
    const platformDetails = useSelector(getPlatformDetailsSelector);

    if (isPlatformIframe(platformDetails)) return <OpenInMilanoteUtil />;

    const href = buildPublicSiteUrl(platformDetails);

    return (
        <CurrentBoardHeaderUtil className="MadeWithMilanoteUtil">
            Made with&nbsp;
            <a href={href} rel="noopener nofollow">
                Milanote
            </a>
        </CurrentBoardHeaderUtil>
    );
};

export default MadeWithMilanoteUtil;
